export const TREND_ASSETS_CHECKBOXES = [
  { value: 'BS2', color: '#006AA6', isBarChart: true },
  { value: 'BS5', color: '#C3D785', isBarChart: true },
  { value: 'BS9', color: '#AE93E1', isBarChart: true },
  { value: 'BS217', color: '#F5CBA3', isBarChart: true },
  { value: 'BS36', color: '#74B49A', isBarChart: true },
  { value: 'BS46', color: '#E3A2A7', isBarChart: true },
  { value: 'BS52', color: '#FF596A', isBarChart: true },
  { value: 'FA201', color: '#00A8B5', isBarChart: true },
  { value: 'RT0172', color: '#F49966', isLineChart: true },
]

export const TREND_LIABILITIES_CHECKBOXES = [
  { value: 'BS76', color: '#006AA6', isBarChart: true },
  { value: 'BS67', color: '#C3D785', isBarChart: true },
  { value: 'BS229', color: '#F5CBA3', isBarChart: true },
  { value: 'FA223', color: '#F49966', isBarChart: true },
  { value: 'BS81', color: '#E3A2A7', isBarChart: true },
  { value: 'FA018', color: '#FF596A', isLineChart: true },
]

export const TREND_EQUITY_CHECKBOXES = [
  { value: 'FA024', color: '#006AA6', isBarChart: true },
  { value: 'BS109', color: '#C3D785', isBarChart: true },
  { value: 'FA025', color: '#AE93E1', isBarChart: true },
  { value: 'RT0173', color: '#F49966', isLineChart: true },
]

export const EACH_YEAR = {
  ASSETS: [
    { id: 'FA222', color: '#006AA6' },
    { id: 'FA202', color: '#F49966' },
    { id: 'FA203', color: '#00A8B5' },
    { id: 'FA204', color: '#D96383' },
    { id: 'FA205', color: '#74B49A' },
    { id: 'FA206', color: '#7F63B9' },
    { id: 'FA207', color: '#FFCD60' },
    { id: 'FA208', color: '#C3D785' },
    { id: 'FA209', color: '#F5CBA3' },
  ],
  PARENT_PIE: [
    { id: 'BS65', color: '#0553A5', nameId: 'FA159' },
    { id: 'BS95', color: '#FFCD60', nameId: 'FA160' },
  ],
  CHILD_PIE: {
    BS65: [
      { id: 'FA224', color: '#4EB1CB' },
      { id: 'FA225', color: '#F49966' },
      { id: 'FA226', color: '#717ECD' },
      { id: 'FA227', color: '#C3D785' },
      { id: 'FA228', color: '#F5CBA3' },
    ],
    BS95: [
      { id: 'FA026', color: '#4EB1CB' },
      { id: 'FA027', color: '#F49966' },
      { id: 'FA028', color: '#C3D785' },
    ],
  },
  BOTTOM_LEFT_PIE: [
    { id: 'FA214', color: '#D96383' },
    { id: 'FA215', color: '#F5CBA3' },
  ],
  BOTTOM_RIGHT_PIE: [
    { id: 'FA216', color: '#006AA6' },
    { id: 'FA217', color: '#00A8B5' },
    { id: 'FA218', color: '#74B49A' },
    { id: 'FA219', color: '#7F63B9' },
    { id: 'FA220', color: '#FF596A' },
    { id: 'FA221', color: '#FFCD60' },
  ],
}

export const TABLE_TABS = [
  {
    label: 'financialAnalysis.ASSET_STRUCTURE',
    key: 0,
    rowIds: [
      'BS2',
      'BS5',
      'BS9',
      'BS217',
      'BS36',
      'BS46',
      'BS52',
      'FA201',
      'RT0172',
      'BS64',
    ],
  },
  {
    label: 'financialAnalysis.LIABILITIES_STRUCTURE',
    key: 1,
    rowIds: ['BS76', 'BS67', 'BS229', 'FA223', 'BS81', 'BS65', 'FA018'],
  },
  {
    label: 'financialAnalysis.EQUITY_STRUCTURE',
    key: 2,
    rowIds: [
      'FA024',
      'FA026',
      'BS109',
      'FA027',
      'FA025',
      'FA028',
      'BS95',
      'RT0173',
    ],
  },
  {
    label: 'financialAnalysis.SHORT_TERM_INVESTMENT',
    key: 3,
    rowIds: ['NI7', 'NI8', 'FA214', 'FA215'],
  },
  {
    label: 'financialAnalysis.LONG_TERM_INVESTMENT',
    key: 4,
    rowIds: [
      'NI72',
      'NI73',
      'NI74',
      'NI75',
      'NI76',
      'NI77',
      'FA216',
      'FA217',
      'FA218',
      'FA219',
      'FA220',
      'FA221',
    ],
  },
]
